exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "cooperation {\n  display: block;\n  margin-bottom: 20px;\n}\ncooperation .check-list li {\n  margin-bottom: 10px;\n  font-weight: 500;\n}\ncooperation .check-list li::before {\n  top: 0;\n}\n\n/* === Mobile === */\n@media (max-width: 768px) {\n  cooperation {\n    margin-bottom: 10px;\n  }\n}", ""]);

// exports
